/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE", "EXPERIMENTAL_OVERRIDE")

package features.getPublicAmazonProductVariants.internal

import features.getPublicAmazonProductVariants.models.PublicRewardResponseModel
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.io.toModel

internal class GetPublicAmazonProductVariantsServiceImpl : GetPublicAmazonProductVariantsService {

    private val getPublicAmazonProductVariantsRequest = GetPublicAmazonProductVariantsRequest()

    override suspend fun getPublicAmazonProductVariants(
        overrideHeaders : Map<String, String>?,
        rewardSlug: String,
        externalProductId: String    ): Result<PublicRewardResponseModel> {
        return getPublicAmazonProductVariantsRequest.getPublicAmazonProductVariants(
            overrideHeaders = overrideHeaders,
            rewardSlug = rewardSlug,
            externalProductId = externalProductId        ).toModel()
    }
}
